"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const graphql_1 = require("../../../graphql");
const ResourceListTable_1 = require("../../Admin/AdminHome/ResourceListTable");
exports.Contexts = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ResourceListTable_1.ResourceListTable, { query: graphql_1.contexts, variables: {}, keys: {
                count: 'contextsCount',
                item: 'contexts',
            }, singular: "context", plural: "contexts", headers: [
                {
                    direction: 'ASC',
                    label: 'Name',
                    name: 'name',
                    width: '65%',
                },
                {
                    direction: 'ASC',
                    label: 'Number of context keys',
                    name: 'keys',
                    width: '35%',
                },
            ], cells: (data) => {
                return [
                    react_1.default.createElement("strong", { className: "text-dark", key: 1 },
                        react_1.default.createElement(react_router_dom_1.Link, { to: `/contexts/${data.id}`, className: "text-reset" }, data.name)),
                    Object.keys(data.contextVariables || {}).length,
                ];
            } })));
};
exports.default = exports.Contexts;
//# sourceMappingURL=index.js.map